import React from 'react';

class Collapsible extends React.Component {
  render() {
    const indicator = (
      <img
        src="https://cdn-assets.alltrails.com/assets/icons/chevron-indicator.png"
        className={this.props.expanded ? 'indicator expanded' : 'indicator collapsed'}
      />
    );
    return (
      <div className="collapsible-container" id={this.props.id ? this.props.id : ''}>
        <h6 className="collapsible-head subtitle2" onClick={this.props.onClick}>
          {this.props.title}
          {indicator}
        </h6>
        <div className={`collapsible-body${!this.props.expanded ? ' collapsed' : ''}`}>{this.props.children}</div>
      </div>
    );
  }
}

export { Collapsible };
